var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"cols":"12"}},[_c('v-progress-linear',{staticClass:"my-0",attrs:{"value":_vm.coreCard.percentComplete,"color":_vm.$coreScores.getColor(
        _vm.$coreScores.reverseFormat(_vm.coreCard.percentComplete)
      ),"background-color":"background","height":"30"},scopedSlots:_vm._u([{key:"default",fn:function(ref){return [_c('div',{staticClass:"benchmark",style:({
          marginLeft: _vm.margin
        })})]}}])}),_c('div',[_c('v-icon',{style:({
        marginLeft: _vm.iconMargin
      }),attrs:{"x-small":"","color":"secondarytext"}},[_vm._v(" insert_chart ")])],1),(_vm.showPossible)?_c('div',[_vm._v(" "+_vm._s(_vm.coreCard.value)+" of "+_vm._s(_vm.coreCard.possible)+" completed ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }